/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
            {
                internalType: "address",
                name: "defaultSender",
                type: "address",
            },
            {
                internalType: "address",
                name: "defaultReceiver",
                type: "address",
            },
            {
                internalType: "address",
                name: "defaultFlowOperator",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
        ],
        name: "authorizeFlowOperatorWithFullControl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
        ],
        name: "createFlow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class CFALibrarySuperAppMock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, defaultSender, defaultReceiver, defaultFlowOperator, overrides) {
        return super.deploy(host, defaultSender, defaultReceiver, defaultFlowOperator, overrides || {});
    }
    getDeployTransaction(host, defaultSender, defaultReceiver, defaultFlowOperator, overrides) {
        return super.getDeployTransaction(host, defaultSender, defaultReceiver, defaultFlowOperator, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
CFALibrarySuperAppMock__factory.bytecode = _bytecode;
CFALibrarySuperAppMock__factory.abi = _abi;
//# sourceMappingURL=CFALibrarySuperAppMock__factory.js.map